import { colors } from 'Constants/Colors';
import styled from 'styled-components';

export const nameStyle = { background: colors.WHITE, width: '100%' };

export const DropzoneContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 1rem;
  background: ${colors.WHITE};
  border-radius: 5px;
  border-color: ${colors.GRAY_HR};
  margin-top: 1rem;
`;

export const DropzoneSubContainer = styled.div`
  border: 2px dashed red;
  background: ${colors.WHITE};
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  border-color: ${colors.GREEN_SHINING_ULTRA};
`;

export const DropzoneArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

export const DropzoneText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const VideoContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 1rem;
`;

export const videoStyle = { margin: 'auto', width: '55%', height: '600' };

export const boxStyle = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: '1rem',
};

export const spanStyle = { color: 'green', textDecoration: 'underline' };

export const backdropStyle = {
  color: '#fff',
  display: 'flex',
  flexDirection: 'column',
  zIndex: theme => theme.zIndex.drawer + 1,
};

export default {
  nameStyle,
  VideoContainer,
  videoStyle,
  spanStyle,
  boxStyle,
  backdropStyle,
};
